<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>{{ title }}</h1>
      <v-row>
        <v-col class="pt-0 mt-0">Date Resigned:</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <custom-datepicker
            :class-padding="classPadding"
            label="Date From"
            v-model="dateFrom"
          ></custom-datepicker>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <custom-datepicker
            :class-padding="classPadding"
            label="Date To"
            v-model="dateTo"
          ></custom-datepicker>
        </v-col>
      </v-row>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>Payroll Location</v-expansion-panel-header>
          <v-expansion-panel-content>
            <pay-loc-pagination
              :show-dense="false"
              :headers="payLocHeaders"
              :show-select="true"
            ></pay-loc-pagination>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Department</v-expansion-panel-header>
          <v-expansion-panel-content>
            <department-selection
              :show-dense="false"
              :show-select="true"
            ></department-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Division</v-expansion-panel-header>
          <v-expansion-panel-content>
            <division-selection
              :show-dense="false"
              :show-select="true"
            ></division-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Branch</v-expansion-panel-header>
          <v-expansion-panel-content>
            <branch-selection
              :show-dense="false"
              :show-select="true"
            ></branch-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Section</v-expansion-panel-header>
          <v-expansion-panel-content>
            <section-selection
              :show-dense="false"
              :show-select="true"
            ></section-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Area</v-expansion-panel-header>
          <v-expansion-panel-content>
            <area-selection
              :show-dense="false"
              :show-select="true"
            ></area-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Group</v-expansion-panel-header>
          <v-expansion-panel-content>
            <group-selection
              :show-dense="false"
              :show-select="true"
            ></group-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Designation</v-expansion-panel-header>
          <v-expansion-panel-content>
            <designation-selection
              :show-dense="false"
              :show-select="true"
            ></designation-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Location</v-expansion-panel-header>
          <v-expansion-panel-content>
            <location-selection
              :show-dense="false"
              :show-select="true"
            ></location-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-row>
        <v-col>
          <v-btn outlined @click.prevent="search" :loading="isSearching"
            >Search</v-btn
          >
        </v-col>
      </v-row>

      <emp-selection
        :items="employees"
        :headers="headers"
        v-if="employees.length > 0"
        :show-select="true"
        :show-dense="false"
        :show-title="false"
        v-model="selectedEmployee"
      ></emp-selection>

      <v-row>
        <v-col>
          <v-btn
            outlined
            @click.prevent="purge"
            :loading="loading"
            v-if="employees.length > 0 && userAccess.submit >= 1"
            color="success"
            >Purge</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import userAccessMixin from "../../../mixins/userAccessMixin";
const CustomDatepicker = () => import("../../../components/CustomDatepicker");
const PayLocPagination = () =>
  import("../../setup/general/payroll-location/PaginationSelection");
const DepartmentSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/department/PaginationSelection"
  );

const DivisionSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/division/PaginationSelection"
  );
const BranchSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/branch/PaginationSelection"
  );

const SectionSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/section/PaginationSelection"
  );

const AreaSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/area/PaginationSelection"
  );
const GroupSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/group/PaginationSelection"
  );

const DesignationSelection = () =>
  import(
    "../../setup/employment-info/employee-level/designation/PaginationSelection"
  );

const LocationSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/location/PaginationSelection"
  );
const EmpSelection = () =>
  import("../../maintenance/employee-masterfile/personal-info/PurgeSelection");
const API_ENDPOINT = "/api/purgeemployee";
import EventBus from "../../../events/eventBus";
export default {
  metaInfo: {
    title: "Purge Employee Masterfile",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  data: () => ({
    title: "Purge Employee Masterfile",
    classPadding: "my-0 py-0",
    dateFrom: null,
    dateTo: null,
    payLocHeaders: [
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId"
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName"
      }
    ],
    payLoc: [],
    department: [],
    division: [],
    branch: [],
    section: [],
    area: [],
    group: [],
    designation: [],
    location: [],
    isSearching: false,
    employees: [],
    headers: [
      {
        text: "Code",
        value: "empCode",
        sortable: false
      },
      {
        text: "Last Name",
        value: "lName",
        sortable: false
      },
      {
        text: "First Name",
        value: "fName",
        sortable: false
      },
      {
        text: "Middle Name",
        value: "mName",
        sortable: false
      }
    ],
    selectedEmployee: [],
    loading: false
  }),
  components: {
    CustomDatepicker,
    PayLocPagination,
    DepartmentSelection,
    DivisionSelection,
    BranchSelection,
    SectionSelection,
    AreaSelection,
    GroupSelection,
    DesignationSelection,
    LocationSelection,
    EmpSelection
  },
  methods: {
    search() {
      this.isSearching = true;
      var data = {
        PayLoc: this.payLoc,
        Departments: this.department,
        Divisions: this.division,
        Branches: this.branch,
        Sections: this.section,
        Areas: this.area,
        Groups: this.group,
        Designations: this.designation,
        Locations: this.location,
        EmpCodes: [],
        DateFrom: this.dateFrom,
        DateTo: this.dateTo
      };
      this.$axios
        .post(`${API_ENDPOINT}`, data)
        .then(({ data }) => {
          // console.log(data);
          this.employees = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSearching = false;
        });
    },
    purge() {
      this.loading = true;
      this.$axios
        .post(`${API_ENDPOINT}/purge`, this.selectedEmployee)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reset() {
      this.dateFrom = null;
      this.dateTo = null;
      this.payLoc = [];
      this.department = [];
      this.division = [];
      this.branch = [];
      this.section = [];
      this.area = [];
      this.group = [];
      this.designation = [];
      this.location = [];
      this.employees = [];
      this.selectedEmployee = [];

      // EventBus.$emit("TOGGLE_SELECTED_EMPLOYEE", []);
      EventBus.$emit("TOGGLE_SELECTED_PAYLOC", []);
      EventBus.$emit("TOGGLE_SELECTED_DEPARTMENT", []);
      EventBus.$emit("TOGGLE_SELECTED_DIVISION", []);
      EventBus.$emit("TOGGLE_SELECTED_BRANCH", []);
      EventBus.$emit("TOGGLE_SELECTED_SECTION", []);
      EventBus.$emit("TOGGLE_SELECTED_AREA", []);
      EventBus.$emit("TOGGLE_SELECTED_GROUP", []);
      EventBus.$emit("TOGGLE_SELECTED_DESIGNATION", []);
      EventBus.$emit("TOGGLE_SELECTED_LOCATION", []);
    }
  },
  mounted() {
    EventBus.$on("SELECTED_PAYLOC", payload => {
      this.payLoc = payload.map(function(item) {
        return item.locId;
      });
    });

    EventBus.$on("SELECTED_DEPARTMENT", payload => {
      this.department = payload.map(function(item) {
        return item.depCode;
      });
    });

    EventBus.$on("SELECTED_DIVISION", payload => {
      this.division = payload.map(function(item) {
        return item.divCode;
      });
    });

    EventBus.$on("SELECTED_BRANCH", payload => {
      this.branch = payload.map(function(item) {
        return item.braCode;
      });
    });

    EventBus.$on("SELECTED_SECTION", payload => {
      this.section = payload.map(function(item) {
        return item.secCode;
      });
    });

    EventBus.$on("SELECTED_AREA", payload => {
      this.area = payload.map(function(item) {
        return item.areaCode;
      });
    });

    EventBus.$on("SELECTED_GROUP", payload => {
      this.group = payload.map(function(item) {
        return item.grpCode;
      });
    });

    EventBus.$on("SELECTED_DESIGNATION", payload => {
      this.designation = payload.map(function(item) {
        return item.desCode;
      });
    });

    EventBus.$on("SELECTED_LOCATION", payload => {
      this.location = payload.map(function(item) {
        return item.locationCode;
      });
    });

    // EventBus.$on("SELECTED_EMPLOYEE", payload => {
    //   console.log(payload)
    //   this.selectedEmployee = payload.map(function(item) {
    //     return item.empCode;
    //   });
    // });
  },
  created() {
    this.getUserAccessRights("PMUTIL");
  }
};
</script>